export default __webpack_public_path__ + "static/media/eye-open.9ac1a0e4.svg";